import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";

import "./identity.scss";
import Sidebar from "../SideBar/SideBar";
import {
  Box,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
} from "@mui/material";
// import Grid from '@mui/material/Grid';
import Grid from "@mui/material/Grid";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import Btc from "../../Img/btc.png";
import eth from "../../Img/eth.png";
import tht from "../../Img/theter.png";
import shiba from "../../Img/shiba.svg";
import mana from "../../Img/mana.svg";

import trending_icon from "../../Img/trending_icon.svg";
import right_arw from "../../Img/right_arw.svg";
import zec from "../../Img/coins/zec.png";
import xec from "../../Img/coins/xec.png";
import kcs from "../../Img/coins/kcs.png";
import scr from "../../Img/coins/scr.png";
import cat from "../../Img/coins/cat.png";
import woop from "../../Img/coins/woop.png";
import pip from "../../Img/coins/pip.png";
import insp from "../../Img/coins/xec.png";
import ese from "../../Img/coins/ese.png";
import sol from "../../Img/coins/sol.png";

import tr1 from "../../Img/tr1.svg";
import tr2 from "../../Img/tr2.svg";
import tr3 from "../../Img/tr3.svg";
import tr4 from "../../Img/tr4.svg";

import g1 from "../../Img/g1.svg";
import g2 from "../../Img/g2.svg";
import g3 from "../../Img/g3.svg";
import g4 from "../../Img/g4.svg";

import consts from "../../constant";
import usercalls from "../../Axios";
import $ from "jquery";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import d1 from "../../Img/d1.png";
import eye from "../../Img/eye.svg";
import wrong from "../../Img/wrong.svg";
import standard from "../../Img/standard.png";
import SideBar from "../SideBar/SideBar";

export default function Documentverification() {
  const countries = [
    { code: "AD", label: "Andorra", phone: "376" },
    {
      code: "AE",
      label: "United Arab Emirates",
      phone: "971",
    },
    { code: "AF", label: "Afghanistan", phone: "93" },
    {
      code: "AG",
      label: "Antigua and Barbuda",
      phone: "1-268",
    },
    { code: "AI", label: "Anguilla", phone: "1-264" },
    { code: "AL", label: "Albania", phone: "355" },
    { code: "AM", label: "Armenia", phone: "374" },
    { code: "AO", label: "Angola", phone: "244" },
    { code: "AQ", label: "Antarctica", phone: "672" },
    { code: "AR", label: "Argentina", phone: "54" },
    { code: "AS", label: "American Samoa", phone: "1-684" },
    { code: "AT", label: "Austria", phone: "43" },
    {
      code: "AU",
      label: "Australia",
      phone: "61",
      suggested: true,
    },
    { code: "AW", label: "Aruba", phone: "297" },
    { code: "AX", label: "Alland Islands", phone: "358" },
    { code: "AZ", label: "Azerbaijan", phone: "994" },
    {
      code: "BA",
      label: "Bosnia and Herzegovina",
      phone: "387",
    },
    { code: "BB", label: "Barbados", phone: "1-246" },
    { code: "BD", label: "Bangladesh", phone: "880" },
    { code: "BE", label: "Belgium", phone: "32" },
    { code: "BF", label: "Burkina Faso", phone: "226" },
    { code: "BG", label: "Bulgaria", phone: "359" },
    { code: "BH", label: "Bahrain", phone: "973" },
    { code: "BI", label: "Burundi", phone: "257" },
    { code: "BJ", label: "Benin", phone: "229" },
    { code: "BL", label: "Saint Barthelemy", phone: "590" },
    { code: "BM", label: "Bermuda", phone: "1-441" },
    { code: "BN", label: "Brunei Darussalam", phone: "673" },
    { code: "BO", label: "Bolivia", phone: "591" },
    { code: "BR", label: "Brazil", phone: "55" },
    { code: "BS", label: "Bahamas", phone: "1-242" },
    { code: "BT", label: "Bhutan", phone: "975" },
    { code: "BV", label: "Bouvet Island", phone: "47" },
    { code: "BW", label: "Botswana", phone: "267" },
    { code: "BY", label: "Belarus", phone: "375" },
    { code: "BZ", label: "Belize", phone: "501" },
    {
      code: "CA",
      label: "Canada",
      phone: "1",
      suggested: true,
    },
    {
      code: "CC",
      label: "Cocos (Keeling) Islands",
      phone: "61",
    },
    {
      code: "CD",
      label: "Congo, Democratic Republic of the",
      phone: "243",
    },
    {
      code: "CF",
      label: "Central African Republic",
      phone: "236",
    },
    {
      code: "CG",
      label: "Congo, Republic of the",
      phone: "242",
    },
    { code: "CH", label: "Switzerland", phone: "41" },
    { code: "CI", label: "Cote d'Ivoire", phone: "225" },
    { code: "CK", label: "Cook Islands", phone: "682" },
    { code: "CL", label: "Chile", phone: "56" },
    { code: "CM", label: "Cameroon", phone: "237" },
    { code: "CN", label: "China", phone: "86" },
    { code: "CO", label: "Colombia", phone: "57" },
    { code: "CR", label: "Costa Rica", phone: "506" },
    { code: "CU", label: "Cuba", phone: "53" },
    { code: "CV", label: "Cape Verde", phone: "238" },
    { code: "CW", label: "Curacao", phone: "599" },
    { code: "CX", label: "Christmas Island", phone: "61" },
    { code: "CY", label: "Cyprus", phone: "357" },
    { code: "CZ", label: "Czech Republic", phone: "420" },
    {
      code: "DE",
      label: "Germany",
      phone: "49",
      suggested: true,
    },
    { code: "DJ", label: "Djibouti", phone: "253" },
    { code: "DK", label: "Denmark", phone: "45" },
    { code: "DM", label: "Dominica", phone: "1-767" },
    {
      code: "DO",
      label: "Dominican Republic",
      phone: "1-809",
    },
    { code: "DZ", label: "Algeria", phone: "213" },
    { code: "EC", label: "Ecuador", phone: "593" },
    { code: "EE", label: "Estonia", phone: "372" },
    { code: "EG", label: "Egypt", phone: "20" },
    { code: "EH", label: "Western Sahara", phone: "212" },
    { code: "ER", label: "Eritrea", phone: "291" },
    { code: "ES", label: "Spain", phone: "34" },
    { code: "ET", label: "Ethiopia", phone: "251" },
    { code: "FI", label: "Finland", phone: "358" },
    { code: "FJ", label: "Fiji", phone: "679" },
    {
      code: "FK",
      label: "Falkland Islands (Malvinas)",
      phone: "500",
    },
    {
      code: "FM",
      label: "Micronesia, Federated States of",
      phone: "691",
    },
    { code: "FO", label: "Faroe Islands", phone: "298" },
    {
      code: "FR",
      label: "France",
      phone: "33",
      suggested: true,
    },
    { code: "GA", label: "Gabon", phone: "241" },
    { code: "GB", label: "United Kingdom", phone: "44" },
    { code: "GD", label: "Grenada", phone: "1-473" },
    { code: "GE", label: "Georgia", phone: "995" },
    { code: "GF", label: "French Guiana", phone: "594" },
    { code: "GG", label: "Guernsey", phone: "44" },
    { code: "GH", label: "Ghana", phone: "233" },
    { code: "GI", label: "Gibraltar", phone: "350" },
    { code: "GL", label: "Greenland", phone: "299" },
    { code: "GM", label: "Gambia", phone: "220" },
    { code: "GN", label: "Guinea", phone: "224" },
    { code: "GP", label: "Guadeloupe", phone: "590" },
    { code: "GQ", label: "Equatorial Guinea", phone: "240" },
    { code: "GR", label: "Greece", phone: "30" },
    {
      code: "GS",
      label: "South Georgia and the South Sandwich Islands",
      phone: "500",
    },
    { code: "GT", label: "Guatemala", phone: "502" },
    { code: "GU", label: "Guam", phone: "1-671" },
    { code: "GW", label: "Guinea-Bissau", phone: "245" },
    { code: "GY", label: "Guyana", phone: "592" },
    { code: "HK", label: "Hong Kong", phone: "852" },
    {
      code: "HM",
      label: "Heard Island and McDonald Islands",
      phone: "672",
    },
    { code: "HN", label: "Honduras", phone: "504" },
    { code: "HR", label: "Croatia", phone: "385" },
    { code: "HT", label: "Haiti", phone: "509" },
    { code: "HU", label: "Hungary", phone: "36" },
    { code: "ID", label: "Indonesia", phone: "62" },
    { code: "IE", label: "Ireland", phone: "353" },
    { code: "IL", label: "Israel", phone: "972" },
    { code: "IM", label: "Isle of Man", phone: "44" },
    { code: "IN", label: "India", phone: "91" },
    {
      code: "IO",
      label: "British Indian Ocean Territory",
      phone: "246",
    },
    { code: "IQ", label: "Iraq", phone: "964" },
    {
      code: "IR",
      label: "Iran, Islamic Republic of",
      phone: "98",
    },
    { code: "IS", label: "Iceland", phone: "354" },
    { code: "IT", label: "Italy", phone: "39" },
    { code: "JE", label: "Jersey", phone: "44" },
    { code: "JM", label: "Jamaica", phone: "1-876" },
    { code: "JO", label: "Jordan", phone: "962" },
    {
      code: "JP",
      label: "Japan",
      phone: "81",
      suggested: true,
    },
    { code: "KE", label: "Kenya", phone: "254" },
    { code: "KG", label: "Kyrgyzstan", phone: "996" },
    { code: "KH", label: "Cambodia", phone: "855" },
    { code: "KI", label: "Kiribati", phone: "686" },
    { code: "KM", label: "Comoros", phone: "269" },
    {
      code: "KN",
      label: "Saint Kitts and Nevis",
      phone: "1-869",
    },
    {
      code: "KP",
      label: "Korea, Democratic People's Republic of",
      phone: "850",
    },
    { code: "KR", label: "Korea, Republic of", phone: "82" },
    { code: "KW", label: "Kuwait", phone: "965" },
    { code: "KY", label: "Cayman Islands", phone: "1-345" },
    { code: "KZ", label: "Kazakhstan", phone: "7" },
    {
      code: "LA",
      label: "Lao People's Democratic Republic",
      phone: "856",
    },
    { code: "LB", label: "Lebanon", phone: "961" },
    { code: "LC", label: "Saint Lucia", phone: "1-758" },
    { code: "LI", label: "Liechtenstein", phone: "423" },
    { code: "LK", label: "Sri Lanka", phone: "94" },
    { code: "LR", label: "Liberia", phone: "231" },
    { code: "LS", label: "Lesotho", phone: "266" },
    { code: "LT", label: "Lithuania", phone: "370" },
    { code: "LU", label: "Luxembourg", phone: "352" },
    { code: "LV", label: "Latvia", phone: "371" },
    { code: "LY", label: "Libya", phone: "218" },
    { code: "MA", label: "Morocco", phone: "212" },
    { code: "MC", label: "Monaco", phone: "377" },
    {
      code: "MD",
      label: "Moldova, Republic of",
      phone: "373",
    },
    { code: "ME", label: "Montenegro", phone: "382" },
    {
      code: "MF",
      label: "Saint Martin (French part)",
      phone: "590",
    },
    { code: "MG", label: "Madagascar", phone: "261" },
    { code: "MH", label: "Marshall Islands", phone: "692" },
    {
      code: "MK",
      label: "Macedonia, the Former Yugoslav Republic of",
      phone: "389",
    },
    { code: "ML", label: "Mali", phone: "223" },
    { code: "MM", label: "Myanmar", phone: "95" },
    { code: "MN", label: "Mongolia", phone: "976" },
    { code: "MO", label: "Macao", phone: "853" },
    {
      code: "MP",
      label: "Northern Mariana Islands",
      phone: "1-670",
    },
    { code: "MQ", label: "Martinique", phone: "596" },
    { code: "MR", label: "Mauritania", phone: "222" },
    { code: "MS", label: "Montserrat", phone: "1-664" },
    { code: "MT", label: "Malta", phone: "356" },
    { code: "MU", label: "Mauritius", phone: "230" },
    { code: "MV", label: "Maldives", phone: "960" },
    { code: "MW", label: "Malawi", phone: "265" },
    { code: "MX", label: "Mexico", phone: "52" },
    { code: "MY", label: "Malaysia", phone: "60" },
    { code: "MZ", label: "Mozambique", phone: "258" },
    { code: "NA", label: "Namibia", phone: "264" },
    { code: "NC", label: "New Caledonia", phone: "687" },
    { code: "NE", label: "Niger", phone: "227" },
    { code: "NF", label: "Norfolk Island", phone: "672" },
    { code: "NG", label: "Nigeria", phone: "234" },
    { code: "NI", label: "Nicaragua", phone: "505" },
    { code: "NL", label: "Netherlands", phone: "31" },
    { code: "NO", label: "Norway", phone: "47" },
    { code: "NP", label: "Nepal", phone: "977" },
    { code: "NR", label: "Nauru", phone: "674" },
    { code: "NU", label: "Niue", phone: "683" },
    { code: "NZ", label: "New Zealand", phone: "64" },
    { code: "OM", label: "Oman", phone: "968" },
    { code: "PA", label: "Panama", phone: "507" },
    { code: "PE", label: "Peru", phone: "51" },
    { code: "PF", label: "French Polynesia", phone: "689" },
    { code: "PG", label: "Papua New Guinea", phone: "675" },
    { code: "PH", label: "Philippines", phone: "63" },
    { code: "PK", label: "Pakistan", phone: "92" },
    { code: "PL", label: "Poland", phone: "48" },
    {
      code: "PM",
      label: "Saint Pierre and Miquelon",
      phone: "508",
    },
    { code: "PN", label: "Pitcairn", phone: "870" },
    { code: "PR", label: "Puerto Rico", phone: "1" },
    {
      code: "PS",
      label: "Palestine, State of",
      phone: "970",
    },
    { code: "PT", label: "Portugal", phone: "351" },
    { code: "PW", label: "Palau", phone: "680" },
    { code: "PY", label: "Paraguay", phone: "595" },
    { code: "QA", label: "Qatar", phone: "974" },
    { code: "RE", label: "Reunion", phone: "262" },
    { code: "RO", label: "Romania", phone: "40" },
    { code: "RS", label: "Serbia", phone: "381" },
    { code: "RU", label: "Russian Federation", phone: "7" },
    { code: "RW", label: "Rwanda", phone: "250" },
    { code: "SA", label: "Saudi Arabia", phone: "966" },
    { code: "SB", label: "Solomon Islands", phone: "677" },
    { code: "SC", label: "Seychelles", phone: "248" },
    { code: "SD", label: "Sudan", phone: "249" },
    { code: "SE", label: "Sweden", phone: "46" },
    { code: "SG", label: "Singapore", phone: "65" },
    { code: "SH", label: "Saint Helena", phone: "290" },
    { code: "SI", label: "Slovenia", phone: "386" },
    {
      code: "SJ",
      label: "Svalbard and Jan Mayen",
      phone: "47",
    },
    { code: "SK", label: "Slovakia", phone: "421" },
    { code: "SL", label: "Sierra Leone", phone: "232" },
    { code: "SM", label: "San Marino", phone: "378" },
    { code: "SN", label: "Senegal", phone: "221" },
    { code: "SO", label: "Somalia", phone: "252" },
    { code: "SR", label: "Suriname", phone: "597" },
    { code: "SS", label: "South Sudan", phone: "211" },
    {
      code: "ST",
      label: "Sao Tome and Principe",
      phone: "239",
    },
    { code: "SV", label: "El Salvador", phone: "503" },
    {
      code: "SX",
      label: "Sint Maarten (Dutch part)",
      phone: "1-721",
    },
    {
      code: "SY",
      label: "Syrian Arab Republic",
      phone: "963",
    },
    { code: "SZ", label: "Swaziland", phone: "268" },
    {
      code: "TC",
      label: "Turks and Caicos Islands",
      phone: "1-649",
    },
    { code: "TD", label: "Chad", phone: "235" },
    {
      code: "TF",
      label: "French Southern Territories",
      phone: "262",
    },
    { code: "TG", label: "Togo", phone: "228" },
    { code: "TH", label: "Thailand", phone: "66" },
    { code: "TJ", label: "Tajikistan", phone: "992" },
    { code: "TK", label: "Tokelau", phone: "690" },
    { code: "TL", label: "Timor-Leste", phone: "670" },
    { code: "TM", label: "Turkmenistan", phone: "993" },
    { code: "TN", label: "Tunisia", phone: "216" },
    { code: "TO", label: "Tonga", phone: "676" },
    { code: "TR", label: "Turkey", phone: "90" },
    {
      code: "TT",
      label: "Trinidad and Tobago",
      phone: "1-868",
    },
    { code: "TV", label: "Tuvalu", phone: "688" },
    {
      code: "TW",
      label: "Taiwan",
      phone: "886",
    },
    {
      code: "TZ",
      label: "United Republic of Tanzania",
      phone: "255",
    },
    { code: "UA", label: "Ukraine", phone: "380" },
    { code: "UG", label: "Uganda", phone: "256" },
    {
      code: "US",
      label: "United States",
      phone: "1",
      suggested: true,
    },
    { code: "UY", label: "Uruguay", phone: "598" },
    { code: "UZ", label: "Uzbekistan", phone: "998" },
    {
      code: "VA",
      label: "Holy See (Vatican City State)",
      phone: "379",
    },
    {
      code: "VC",
      label: "Saint Vincent and the Grenadines",
      phone: "1-784",
    },
    { code: "VE", label: "Venezuela", phone: "58" },
    {
      code: "VG",
      label: "British Virgin Islands",
      phone: "1-284",
    },
    {
      code: "VI",
      label: "US Virgin Islands",
      phone: "1-340",
    },
    { code: "VN", label: "Vietnam", phone: "84" },
    { code: "VU", label: "Vanuatu", phone: "678" },
    { code: "WF", label: "Wallis and Futuna", phone: "681" },
    { code: "WS", label: "Samoa", phone: "685" },
    { code: "XK", label: "Kosovo", phone: "383" },
    { code: "YE", label: "Yemen", phone: "967" },
    { code: "YT", label: "Mayotte", phone: "262" },
    { code: "ZA", label: "South Africa", phone: "27" },
    { code: "ZM", label: "Zambia", phone: "260" },
    { code: "ZW", label: "Zimbabwe", phone: "263" },
  ];

  return (
    <div>
      <div>
        <Header />
        <div className="main_flx">
          <Sidebar />

          <div style={{ width: "100%" }}>
            <div className="abvbar split_half">
              <h6>Individual Identity Verification</h6>
            </div>
            <div className="split_half mt-30">
              <Grid container spacing={5}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <div className="doc_verify">
                    <h4>Document Verification</h4>
                    <p>
                      Your ID document will be scanned for personal data
                      extraction.
                    </p>
                    <div className="input_box mb-10">
                      <Autocomplete
                        id="country-select-demo"
                        options={countries}
                        autoHighlight
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option) => {
                          const { key, ...optionProps } = props;
                          return (
                            <Box
                              key={key}
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...optionProps}
                            >
                              <img
                                loading="lazy"
                                width="20"
                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                alt=""
                              />
                              {option.label} ({option.code}) +{option.phone}
                            </Box>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              borderRadius: "50px",
                              "& .MuiInputBase-formControl": {
                                borderRadius: "10px",
                                backgroundColor: "#f5f5f5",
                              },
                              "& .MuiInputBase-input": {
                                padding: "11px 30px",
                                border: "0",
                              },
                              "& fieldset": {
                                border: "0px solid #d3d1d1 !important",
                              },
                              "& .MuiInputBase-input::placeholder": {
                                color: "black",
                                fontSize: "15px",
                              },
                            }}
                            {...params}
                            slotProps={{
                              htmlInput: {
                                ...params.inputProps,
                                autoComplete: "new-password", // disable autocomplete and autofill
                              },
                            }}
                          />
                        )}
                      />
                    </div>

                    <p>These Document Needed</p>
                    <div className="box">
                      <svg
                        width="24"
                        height="19"
                        viewBox="0 0 24 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.29085 3.97209H14.7132C15.2589 3.97209 15.7013 3.52965 15.7013 2.98397V2.31539C15.7013 1.76971 15.2589 1.32727 14.7132 1.32727H14.4084V0.90941C14.4084 0.491549 14.0692 0.152344 13.6514 0.152344H10.3527C9.93485 0.152344 9.59565 0.491549 9.59565 0.90941V1.32727H9.29085C8.74518 1.32727 8.30273 1.76971 8.30273 2.31539V2.98397C8.30273 3.53456 8.74518 3.97209 9.29085 3.97209Z"
                          fill="#566FFF"
                        />
                        <path
                          d="M21.2421 2.73828H16.6112V2.98408C16.6112 4.03119 15.7558 4.88658 14.7087 4.88658H9.29127C8.24416 4.88658 7.38878 4.03119 7.38878 2.98408V2.73828H2.75789C1.23392 2.73828 0 3.9722 0 5.49617V16.0902C0 17.6142 1.23392 18.8481 2.75789 18.8481H21.2421C22.7661 18.8481 24 17.6142 24 16.0902V5.49617C24 3.97712 22.7661 2.73828 21.2421 2.73828ZM6.90701 15.5691C4.27202 15.5691 2.13355 13.4306 2.13355 10.7956C2.13355 8.16065 4.27202 6.02218 6.90701 6.02218C9.54199 6.02218 11.6805 8.16065 11.6805 10.7956C11.6805 13.4306 9.54691 15.5691 6.90701 15.5691ZM21.306 13.4749H13.2487V12.4474H21.3011V13.4749H21.306ZM21.306 11.3069H13.2487V10.2795H21.3011V11.3069H21.306ZM21.306 9.13894H13.2487V8.11149H21.3011V9.13894H21.306Z"
                          fill="#566FFF"
                        />
                        <path
                          d="M6.92154 6.94141C4.79291 6.94141 3.06738 8.66693 3.06738 10.7956C3.06738 11.7099 3.38692 12.5506 3.91785 13.2093C3.95227 12.8996 4.085 12.5457 4.47828 12.4473C5.23535 12.2556 5.84985 11.823 5.84985 11.823L6.42011 13.6223L6.49876 13.8681L6.7544 13.1454C6.11531 12.2556 6.92154 12.29 6.92154 12.29C6.92154 12.29 7.72777 12.2556 7.08869 13.1454L7.3394 13.8632L7.41806 13.6223V13.6272L7.50655 13.3421L7.9834 11.8279C7.9834 11.8279 8.5979 12.2605 9.35497 12.4523C9.74825 12.5506 9.88098 12.9045 9.9154 13.2142C10.4463 12.5555 10.7659 11.7149 10.7659 10.8005C10.7757 8.66693 9.05018 6.94141 6.92154 6.94141ZM8.44551 10.3433C8.34719 10.6972 8.24887 10.8005 8.18004 10.8054C8.11613 11.2282 7.77693 11.764 7.25091 11.9557C7.02969 12.0344 6.78881 12.0344 6.56759 11.9557C6.03174 11.764 5.70237 11.2282 5.63846 10.8054C5.56964 10.8005 5.47132 10.7022 5.373 10.3433C5.23535 9.8566 5.38283 9.78286 5.50573 9.79761C5.48115 9.72879 5.4664 9.66488 5.45165 9.59606C5.40741 9.36992 5.39758 9.15853 5.44674 8.95206C5.51064 8.68168 5.65812 8.46537 5.82035 8.29331C5.92359 8.18516 6.04157 8.08684 6.16447 8.00818C6.26771 7.93936 6.38078 7.87545 6.49876 7.83612C6.59708 7.80171 6.6954 7.78205 6.80356 7.77713C7.13785 7.74763 7.38856 7.83121 7.57046 7.93936C7.84084 8.08684 7.94407 8.28839 7.94407 8.28839C7.94407 8.28839 8.56349 8.33264 8.35702 9.59606C8.34719 9.65996 8.32752 9.72879 8.30294 9.79761C8.43567 9.78778 8.58316 9.8566 8.44551 10.3433Z"
                          fill="#566FFF"
                        />
                      </svg>
                      <div>Aadhaar card</div>
                    </div>
                    <div className="box">
                      <svg
                        width="24"
                        height="21"
                        viewBox="0 0 24 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.25 9.375C7.62863 9.375 7.125 9.87863 7.125 10.5V11.25C7.125 11.8714 7.62863 12.375 8.25 12.375C8.87137 12.375 9.375 11.8714 9.375 11.25V10.5C9.375 9.87863 8.87137 9.375 8.25 9.375Z"
                          fill="#566FFF"
                        />
                        <path
                          d="M8.25 7.125C5.76487 7.125 3.75 9.13987 3.75 11.625C3.75 12.777 4.18688 13.8251 4.899 14.6209C5.37863 13.9972 6.38025 13.125 8.25 13.125C7.21425 13.125 6.375 12.2857 6.375 11.25V10.5C6.375 9.46425 7.21425 8.625 8.25 8.625C9.28575 8.625 10.125 9.46425 10.125 10.5V11.25C10.125 12.2857 9.28575 13.125 8.25 13.125C10.1198 13.125 11.1214 13.9972 11.601 14.6209C12.3131 13.8251 12.75 12.777 12.75 11.625C12.75 9.13987 10.7351 7.125 8.25 7.125Z"
                          fill="#566FFF"
                        />
                        <path
                          d="M8.24994 13.875C6.61456 13.875 5.79631 14.655 5.44531 15.1403C6.21444 15.7553 7.18831 16.125 8.24994 16.125C9.31156 16.125 10.2854 15.7553 11.0549 15.1403C10.7043 14.6558 9.88606 13.875 8.24994 13.875Z"
                          fill="#566FFF"
                        />
                        <path
                          d="M22.5 2.625H19.5V0.75C19.5 0.542625 19.3324 0.375 19.125 0.375H16.875C16.6676 0.375 16.5 0.542625 16.5 0.75V2.625H7.5V0.75C7.5 0.542625 7.33238 0.375 7.125 0.375H4.875C4.66762 0.375 4.5 0.542625 4.5 0.75V2.625H1.5C0.670875 2.625 0 3.29588 0 4.125V19.125C0 19.9541 0.670875 20.625 1.5 20.625H22.5C23.3291 20.625 24 19.9541 24 19.125V4.125C24 3.29588 23.3291 2.625 22.5 2.625ZM17.25 1.125H18.75V4.125H17.25V1.125ZM15.375 7.875H17.625C17.8324 7.875 18 8.04262 18 8.25C18 8.45737 17.8324 8.625 17.625 8.625H15.375C15.1676 8.625 15 8.45737 15 8.25C15 8.04262 15.1676 7.875 15.375 7.875ZM5.25 1.125H6.75V4.125H5.25V1.125ZM8.25 16.875C5.35087 16.875 3 14.5241 3 11.625C3 8.72587 5.35087 6.375 8.25 6.375C11.1491 6.375 13.5 8.72587 13.5 11.625C13.5 14.5241 11.1491 16.875 8.25 16.875ZM20.625 15.375H15.375C15.1676 15.375 15 15.2074 15 15C15 14.7926 15.1676 14.625 15.375 14.625H20.625C20.8324 14.625 21 14.7926 21 15C21 15.2074 20.8324 15.375 20.625 15.375ZM15 12.75C15 12.5426 15.1676 12.375 15.375 12.375H19.125C19.3324 12.375 19.5 12.5426 19.5 12.75C19.5 12.9574 19.3324 13.125 19.125 13.125H15.375C15.1676 13.125 15 12.9574 15 12.75ZM20.625 10.875H15.375C15.1676 10.875 15 10.7074 15 10.5C15 10.2926 15.1676 10.125 15.375 10.125H20.625C20.8324 10.125 21 10.2926 21 10.5C21 10.7074 20.8324 10.875 20.625 10.875Z"
                          fill="#566FFF"
                        />
                      </svg>
                      <div>Pan Card</div>
                    </div>
                    <div className="box">
                      <svg
                        width="24"
                        height="21"
                        viewBox="0 0 24 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.5537 3.77857H11.8126V2.05879C11.8126 1.37374 11.2572 0.818359 10.5722 0.818359H5.5353C4.85026 0.818359 4.29487 1.37374 4.29487 2.05879V3.77865H1.44628C0.647517 3.77857 0 4.42609 0 5.22486V18.7349C0 19.5338 0.647517 20.1813 1.44628 20.1813H22.5537C23.3525 20.1813 24 19.5338 24 18.7349V5.22486C24 4.42609 23.3525 3.77857 22.5537 3.77857ZM17.047 15.7994C17.047 16.4254 16.5395 16.9329 15.9135 16.9329H3.96918C3.34325 16.9329 2.8357 16.4254 2.8357 15.7994V8.16035C2.8357 7.53441 3.34325 7.02687 3.96918 7.02687H15.9135C16.5395 7.02687 17.047 7.53441 17.047 8.16035V15.7994ZM20.4522 12.2609C19.8961 12.2609 19.4452 11.81 19.4452 11.2538C19.4452 10.6977 19.8961 10.2468 20.4522 10.2468C21.0084 10.2468 21.4593 10.6977 21.4593 11.2538C21.4593 11.81 21.0085 12.2609 20.4522 12.2609ZM20.4522 8.38496C19.8961 8.38496 19.4452 7.93404 19.4452 7.37793C19.4452 6.82182 19.8961 6.37098 20.4522 6.37098C21.0084 6.37098 21.4593 6.82182 21.4593 7.37793C21.4593 7.93412 21.0085 8.38496 20.4522 8.38496Z"
                          fill="#566FFF"
                        />
                        <path
                          d="M9.94086 12.6231C9.14089 12.6231 8.41533 12.2998 7.88701 11.7773C7.41764 12.2797 7.12988 12.9538 7.12988 13.6956V15.5279C7.12988 15.8146 7.36231 16.0469 7.64894 16.0469H12.2328C12.5194 16.0469 12.7518 15.8145 12.7518 15.5279V13.6956C12.7518 12.9538 12.4641 12.2797 11.9948 11.7774C11.4666 12.2999 10.7408 12.6231 9.94086 12.6231Z"
                          fill="#566FFF"
                        />
                        <path
                          d="M9.94144 11.4141C10.8885 11.4141 11.6563 10.6463 11.6563 9.69925C11.6563 8.75215 10.8885 7.98438 9.94144 7.98438C8.99434 7.98438 8.22656 8.75215 8.22656 9.69925C8.22656 10.6463 8.99434 11.4141 9.94144 11.4141Z"
                          fill="#566FFF"
                        />
                      </svg>
                      <div>Selfie Verification</div>
                    </div>
                    <br />
                    <Link
                      to={"/individual-verification"}
                      className="org_btn sm_txt"
                      style={{
                        padding: "12px 60px",
                        marginBottom: "10px",
                        display: "inline-block",
                      }}
                    >
                      Continue
                    </Link>
                    <br />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <div className="custom_acc box_bdr">
                    <h5>FAQ</h5>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>What is Identity Verification?</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          Identity Verification (KYC) is a process where
                          Dreamster-Exchange verifies your identity through
                          personal documents. It's required to access features
                          like withdrawals and rewards.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography>
                          Why do I need to complete Identity Verification?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          Identity Verification is required to comply with
                          regulations, enhance account security, and unlock key
                          features like withdrawals, bonuses, and rewards.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                      >
                        <Typography>
                          Which documents and information are required for
                          Identity Verification?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          For Identity Verification, you'll need to provide a
                          valid government-issued ID (National ID), proof of
                          address, and a selfie to confirm your identity.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel4a-content"
                        id="panel4a-header"
                      >
                        <Typography>
                          Where can I find help for issues regarding Identity
                          Verification?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          You can find help in the 'Support' section of
                          Dreamster-Exchange or contact customer service
                          directly for assistance with any Identity Verification
                          issues.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
